// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Backdrop ─────────────────────────────────────────────────── */
.modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(10, 22, 51, 0.42);
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(2px);
  /* A modal overlays everything below toasts. Was z-index:100, which put it at
     the sticky-chrome level — BELOW dropdowns (1000), so menus painted over it. */
  z-index: var(--z-modal, 1600);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}

/* Modals enter at ~280ms ease-out, using the same dur-3/ease tokens as the
   page-enter \`.reveal\` class. */
@media (prefers-reduced-motion: no-preference) {
  .modal-backdrop {
    animation: modal-backdrop-in var(--dur-3) var(--ease);
  }
  .modal-card {
    animation: modal-card-in var(--dur-3) var(--ease);
  }
}
@keyframes modal-backdrop-in {
  from {
    opacity: 0;
  }
}
@keyframes modal-card-in {
  from {
    opacity: 0;
    transform: translateY(6px);
  }
}

/* ── Card ─────────────────────────────────────────────────────── */
.modal-card {
  width: 100%;
  background: var(--bg);
  border: 1px solid var(--border);
  border-radius: var(--r-dialog);
  overflow: hidden;
  color: var(--text);
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  /* Never taller than the viewport minus the backdrop padding (24px × 2): head
     and foot stay pinned, only .modal-body scrolls. vh is the fallback for
     browsers without dvh. */
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 48px);
  max-height: calc(100dvh - 48px);
}

/* Flat variant (opt-in): no shadow and no blur. The scrim stays so the page
   behind still reads as inactive. */
.modal-backdrop--flat {
  backdrop-filter: none;
  -webkit-backdrop-filter: none;
}
.modal-card--flat {
  box-shadow: none;
}

/* ── Header ───────────────────────────────────────────────────── */
.modal-head {
  padding: 16px 20px;
  border-bottom: 1px solid var(--border);
  display: flex;
  align-items: baseline;
  gap: 10px;
  flex-shrink: 0;
}

.modal-head h3 {
  font-family: var(--display);
  font-weight: 400;
  font-size: var(--fs-title-sm);
  margin: 0;
  color: var(--text);
  letter-spacing: -0.005em;
}

/* Eyebrow kicker above the title (same voice as .page .kicker — modals render
   outside .page, so the utility doesn't reach here). */
.modal-head__stack {
  display: flex;
  flex-direction: column;
  gap: 3px;
}
.modal-kicker {
  font-family: var(--mono);
  font-size: var(--fs-eyebrow);
  font-weight: 500;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  color: var(--ink-3);
}

.modal-close {
  margin-left: auto;
  color: var(--text-muted);
  font-family: var(--mono);
  font-size: var(--fs-sm);
  padding: 2px 6px;
  border: 1px solid var(--border);
  border-radius: var(--radius-1, 2px);
  background: transparent;
  cursor: pointer;
  line-height: 1.5;
  transition:
    background 120ms ease,
    color 120ms ease;
}

/* Modal close (×) button — square with --radius-1. */
.modal__x {
  border-radius: var(--radius-1, 2px);
}

.modal-close:hover {
  background: var(--bg-alt);
  color: var(--text-secondary);
}

/* ── Body ─────────────────────────────────────────────────────── */
.modal-body {
  padding: 20px;
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
}

/* ── Foot ─────────────────────────────────────────────────────── */
.modal-foot {
  padding: 14px 20px;
  border-top: 1px solid var(--border);
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  background: var(--bg-alt);
  flex-shrink: 0;
}

/* ── Dark mode ────────────────────────────────────────────────── */
[data-theme='dark'] .modal-card,
.dark .modal-card {
  background: var(--ink-dark-2, #0e1b3d);
  border-color: var(--ink-rule, rgba(242, 227, 181, 0.18));
  color: var(--ink-text, #f2efe6);
}

[data-theme='dark'] .modal-head,
.dark .modal-head {
  border-color: var(--ink-rule, rgba(242, 227, 181, 0.18));
}

[data-theme='dark'] .modal-head h3,
.dark .modal-head h3 {
  color: var(--ink-text, #f2efe6);
}

[data-theme='dark'] .modal-close,
.dark .modal-close {
  color: var(--ink-text-3, #7b829a);
  border-color: var(--ink-rule, rgba(242, 227, 181, 0.18));
}

[data-theme='dark'] .modal-close:hover,
.dark .modal-close:hover {
  background: var(--ink-dark-2, #0e1b3d);
  color: var(--ink-text-2, #b5bbcb);
}

[data-theme='dark'] .modal-foot,
.dark .modal-foot {
  background: var(--ink-dark, #0a1633);
  border-color: var(--ink-rule, rgba(242, 227, 181, 0.18));
}
`, "",{"version":3,"sources":["webpack://./src/ui/Modal/Modal.css"],"names":[],"mappings":"AAAA,oEAAoE;AACpE;EACE,eAAe;EACf,QAAQ;EACR,kCAAkC;EAClC,0BAA0B;EAC1B,kCAAkC;EAClC;kFACgF;EAChF,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;gCACgC;AAChC;EACE;IACE,qDAAqD;EACvD;EACA;IACE,iDAAiD;EACnD;AACF;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;AACF;;AAEA,oEAAoE;AACpE;EACE,WAAW;EACX,qBAAqB;EACrB,+BAA+B;EAC/B,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,0CAA0C;EAC1C;;4BAE0B;EAC1B,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;oCACoC;AACpC;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;AACA;EACE,gBAAgB;AAClB;;AAEA,oEAAoE;AACpE;EACE,kBAAkB;EAClB,sCAAsC;EACtC,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,6BAA6B;EAC7B,SAAS;EACT,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;uDACuD;AACvD;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,wBAAwB;EACxB,4BAA4B;EAC5B,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,wBAAwB;EACxB,uBAAuB;EACvB,gBAAgB;EAChB,+BAA+B;EAC/B,mCAAmC;EACnC,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB;;oBAEkB;AACpB;;AAEA,qDAAqD;AACrD;EACE,mCAAmC;AACrC;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA,oEAAoE;AACpE;EACE,aAAa;EACb,cAAc;EACd,aAAa;EACb,gBAAgB;AAClB;;AAEA,oEAAoE;AACpE;EACE,kBAAkB;EAClB,mCAAmC;EACnC,aAAa;EACb,QAAQ;EACR,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;AAChB;;AAEA,oEAAoE;AACpE;;EAEE,sCAAsC;EACtC,wDAAwD;EACxD,+BAA+B;AACjC;;AAEA;;EAEE,wDAAwD;AAC1D;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,iCAAiC;EACjC,wDAAwD;AAC1D;;AAEA;;EAEE,sCAAsC;EACtC,iCAAiC;AACnC;;AAEA;;EAEE,oCAAoC;EACpC,wDAAwD;AAC1D","sourcesContent":["/* ── Backdrop ─────────────────────────────────────────────────── */\n.modal-backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(10, 22, 51, 0.42);\n  backdrop-filter: blur(2px);\n  -webkit-backdrop-filter: blur(2px);\n  /* A modal overlays everything below toasts. Was z-index:100, which put it at\n     the sticky-chrome level — BELOW dropdowns (1000), so menus painted over it. */\n  z-index: var(--z-modal, 1600);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n}\n\n/* Modals enter at ~280ms ease-out, using the same dur-3/ease tokens as the\n   page-enter `.reveal` class. */\n@media (prefers-reduced-motion: no-preference) {\n  .modal-backdrop {\n    animation: modal-backdrop-in var(--dur-3) var(--ease);\n  }\n  .modal-card {\n    animation: modal-card-in var(--dur-3) var(--ease);\n  }\n}\n@keyframes modal-backdrop-in {\n  from {\n    opacity: 0;\n  }\n}\n@keyframes modal-card-in {\n  from {\n    opacity: 0;\n    transform: translateY(6px);\n  }\n}\n\n/* ── Card ─────────────────────────────────────────────────────── */\n.modal-card {\n  width: 100%;\n  background: var(--bg);\n  border: 1px solid var(--border);\n  border-radius: var(--r-dialog);\n  overflow: hidden;\n  color: var(--text);\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n  /* Never taller than the viewport minus the backdrop padding (24px × 2): head\n     and foot stay pinned, only .modal-body scrolls. vh is the fallback for\n     browsers without dvh. */\n  display: flex;\n  flex-direction: column;\n  max-height: calc(100vh - 48px);\n  max-height: calc(100dvh - 48px);\n}\n\n/* Flat variant (opt-in): no shadow and no blur. The scrim stays so the page\n   behind still reads as inactive. */\n.modal-backdrop--flat {\n  backdrop-filter: none;\n  -webkit-backdrop-filter: none;\n}\n.modal-card--flat {\n  box-shadow: none;\n}\n\n/* ── Header ───────────────────────────────────────────────────── */\n.modal-head {\n  padding: 16px 20px;\n  border-bottom: 1px solid var(--border);\n  display: flex;\n  align-items: baseline;\n  gap: 10px;\n  flex-shrink: 0;\n}\n\n.modal-head h3 {\n  font-family: var(--display);\n  font-weight: 400;\n  font-size: var(--fs-title-sm);\n  margin: 0;\n  color: var(--text);\n  letter-spacing: -0.005em;\n}\n\n/* Eyebrow kicker above the title (same voice as .page .kicker — modals render\n   outside .page, so the utility doesn't reach here). */\n.modal-head__stack {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n.modal-kicker {\n  font-family: var(--mono);\n  font-size: var(--fs-eyebrow);\n  font-weight: 500;\n  letter-spacing: 0.2em;\n  text-transform: uppercase;\n  color: var(--ink-3);\n}\n\n.modal-close {\n  margin-left: auto;\n  color: var(--text-muted);\n  font-family: var(--mono);\n  font-size: var(--fs-sm);\n  padding: 2px 6px;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-1, 2px);\n  background: transparent;\n  cursor: pointer;\n  line-height: 1.5;\n  transition:\n    background 120ms ease,\n    color 120ms ease;\n}\n\n/* Modal close (×) button — square with --radius-1. */\n.modal__x {\n  border-radius: var(--radius-1, 2px);\n}\n\n.modal-close:hover {\n  background: var(--bg-alt);\n  color: var(--text-secondary);\n}\n\n/* ── Body ─────────────────────────────────────────────────────── */\n.modal-body {\n  padding: 20px;\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-y: auto;\n}\n\n/* ── Foot ─────────────────────────────────────────────────────── */\n.modal-foot {\n  padding: 14px 20px;\n  border-top: 1px solid var(--border);\n  display: flex;\n  gap: 8px;\n  justify-content: flex-end;\n  background: var(--bg-alt);\n  flex-shrink: 0;\n}\n\n/* ── Dark mode ────────────────────────────────────────────────── */\n[data-theme='dark'] .modal-card,\n.dark .modal-card {\n  background: var(--ink-dark-2, #0e1b3d);\n  border-color: var(--ink-rule, rgba(242, 227, 181, 0.18));\n  color: var(--ink-text, #f2efe6);\n}\n\n[data-theme='dark'] .modal-head,\n.dark .modal-head {\n  border-color: var(--ink-rule, rgba(242, 227, 181, 0.18));\n}\n\n[data-theme='dark'] .modal-head h3,\n.dark .modal-head h3 {\n  color: var(--ink-text, #f2efe6);\n}\n\n[data-theme='dark'] .modal-close,\n.dark .modal-close {\n  color: var(--ink-text-3, #7b829a);\n  border-color: var(--ink-rule, rgba(242, 227, 181, 0.18));\n}\n\n[data-theme='dark'] .modal-close:hover,\n.dark .modal-close:hover {\n  background: var(--ink-dark-2, #0e1b3d);\n  color: var(--ink-text-2, #b5bbcb);\n}\n\n[data-theme='dark'] .modal-foot,\n.dark .modal-foot {\n  background: var(--ink-dark, #0a1633);\n  border-color: var(--ink-rule, rgba(242, 227, 181, 0.18));\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
